import { render, staticRenderFns } from "./muharram.vue?vue&type=template&id=1d24a008"
import script from "./muharram.vue?vue&type=script&lang=js"
export * from "./muharram.vue?vue&type=script&lang=js"
import style0 from "./muharram.vue?vue&type=style&index=0&id=1d24a008&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports